// extracted by mini-css-extract-plugin
export default {"link-container":"link-container--DgaBv","linkContainer":"link-container--DgaBv","icon-row":"icon-row--JtOnp","iconRow":"icon-row--JtOnp"};